import * as React from 'react';
import { ATTENTION, DANGER } from 'actions/notification/notification';
import { Col, Row } from 'reactstrap';
import { Icon, IconCol, Message, Title } from './NotificationMessage.style';
import ErrorIcon from 'img/icons/Error.png';
import PropTypes from 'prop-types';
import SuccessIcon from 'img/icons/Notification.png';

export const getIconBycategory = (category) => {
  switch (category) {
    case ATTENTION:
      return SuccessIcon;
    case DANGER:
      return ErrorIcon;
    default:
      return null;
  }
};

export const NotificationMessageComponent = (
  { category, title, messages = [] },
  { t }
) => (
  <Row>
    <IconCol>
      <Icon src={getIconBycategory(category)} />
    </IconCol>
    <Col xs={10}>
      <Title> {t(title)} </Title>
      <Message> {messages.map((message) => t(message)).join('\n')}</Message>
    </Col>
  </Row>
);

NotificationMessageComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default NotificationMessageComponent;



// WEBPACK FOOTER //
// ./src/components/common/Notification/NotificationMessage/NotificationMessageComponent.js